module.exports = __webpack_public_path__ + "static/simulators-73652ad359f79461737b60aaf1dcc45a.png";